var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTicket(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 16,
    viewBox: "0 0 21 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.08 12.8L10.5 10.5L6.92 12.8L8 8.68L4.71 6L8.96 5.74L10.5 1.8L12.04 5.74L16.29 6L13 8.68M18.5 8C18.5 7.46957 18.7107 6.96086 19.0858 6.58579C19.4609 6.21071 19.9696 6 20.5 6V2C20.5 1.46957 20.2893 0.960859 19.9142 0.585786C19.5391 0.210714 19.0304 0 18.5 0H2.5C1.96957 0 1.46086 0.210714 1.08579 0.585786C0.710714 0.960859 0.5 1.46957 0.5 2V6C1.03043 6 1.53914 6.21071 1.91421 6.58579C2.28929 6.96086 2.5 7.46957 2.5 8C2.5 8.53043 2.28929 9.03914 1.91421 9.41421C1.53914 9.78929 1.03043 10 0.5 10V14C0.5 14.5304 0.710714 15.0391 1.08579 15.4142C1.46086 15.7893 1.96957 16 2.5 16H18.5C19.0304 16 19.5391 15.7893 19.9142 15.4142C20.2893 15.0391 20.5 14.5304 20.5 14V10C19.9696 10 19.4609 9.78929 19.0858 9.41421C18.7107 9.03914 18.5 8.53043 18.5 8Z",
    fill: "#FF5C29"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTicket);
export default __webpack_public_path__ + "static/media/ticket.3b4b3b2f561390a1be89095353e676f1.svg";
export { ForwardRef as ReactComponent };